import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import Accounts from 'components/common/accounts';

import customer from './customerInfo';
// import advertising from './advertisingInfo';

import './SelectAccount.css';

class SelectAccount extends Component {
  constructor(props) {
    super(props);

    // for local development
    // const data = (props.step === 0) ? customer : advertising;
    // const selected = (props.step === 0) ? props.state.crms : props.state.ad_networks;

    const data = customer;
    const selected = ['Intercom'];

    //// end

    this.state = {
      step: props.step,
      title: data.title,
      description: data.description,
      info: data.info,
      isContinue: (selected.length > 0),
      selected
    };

    _.bindAll(this, ['handleContinue']);
  }


  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      const selected = (nextProps.step === 0) ? nextProps.selectedCustomer : nextProps.selectedAdvertising;
      this.setState({
        selected
      })
    }
  }


  handleContinue() {
    if (this.state.isContinue) {
      this.props.handleChangeTab(this.state.step + 1);
    }
  }


  render() {
    return (
      <div className='select-account'>
        <h1>{this.state.title}</h1>

        <p className='description' dangerouslySetInnerHTML={{__html: this.state.description}} />

        <Accounts
          info={this.state.info}
          selected={this.state.selected}
          onError={this.props.handleOpenModal}
        />

        <button
          className={`btn btn-next ${(this.state.isContinue) ? 'active' : 'disabled'}`}
          onClick={this.handleContinue}
        >Continue</button>

        <p className='select-account__marking'>*To continue you must connect<br/>at least one account.</p>
      </div>
    );
  }
}

function mapStateToProps(stateRedux) {
  const steps = stateRedux.steps;
  const state = stateRedux.steps.state;
  return {steps, state};
}

export default connect(mapStateToProps)(SelectAccount);



// WEBPACK FOOTER //
// ./src/components/core/steps/selectAccount/SelectAccount.jsx